/* Thomvale tv-cart.js v10 (2026-05-29) — IN-PLACE ARCHITECTURE
   ------------------------------------------------------------------
   Why this is different from v1-v9:
     Previous versions POSTed to /cart/{add,change}.js with sections=cart-drawer,
     got back fresh HTML, and dispatched cart:change. Impact's <cart-drawer>
     web-component listened to cart:change and did `replaceChildren()` with the
     fresh HTML — wiping ALL drawer DOM state (incl. our recs cache, qty values,
     toggle position) and forcing a flicker / "loading" state on every action.

   v10 NEVER triggers Impact's full re-render:
     - POSTs WITHOUT sections=cart-drawer (no fresh HTML in response)
     - DOES NOT dispatch cart:change (so Impact's CartDrawer doesn't fire)
     - Updates the drawer DOM in-place after every action: qty number, line price,
       progress bar (msg / fill / nodes / labels), total in CHECKOUT button,
       cart-count bubble, shipping protection toggle state
     - Builds a fresh <div class="tv-li"> from scratch when a recs +Add fires,
       using buildLineItemHTML() that mirrors snippets/tv-line-item.liquid output
     - Trash removes the <div class="tv-li"> with a height-collapse animation
     - When the cart goes empty, swaps the drawer to the server-rendered empty
       state via a one-time cart:refresh (cart:refresh only triggers the header
       cart-count update, not a drawer rebuild)
     - Dispatches cart:refresh (NOT cart:change) so the header cart-count + other
       outside listeners stay in sync
*/
(function () {
  if (window.__tvCartV10) return;
  window.__tvCartV10 = true;

  var PROTECT = 57270832169343;
  var OPTOUT = 'tv_protect_off';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lock = false;
  var recsKey = '';
  var recsHtml = '';

  // ---------- locale + currency helpers ----------
  function locale() {
    var l = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    if (l.indexOf('fr') === 0) return 'fr';
    if (l.indexOf('el') === 0) return 'el';
    if (l.indexOf('es') === 0) return 'es';
    if (l.indexOf('it') === 0) return 'it';
    return 'en';
  }
  function addLabel() {
    var L = locale();
    return L === 'fr' ? '+ Ajouter' : L === 'el' ? '+ Προσθήκη' : L === 'es' ? '+ Añadir' : L === 'it' ? '+ Aggiungi' : '+ Add';
  }
  function moneyFmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function moneyShop(cents) {
    // matches Shopify's `money` filter output (no currency suffix, just symbol)
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) {
      return moneyFmt(cents);
    }
  }

  // ---------- progress bar copy (localized, mirrors section liquid) ----------
  function progressHtml(qty) {
    var L = locale();
    if (qty >= 5) {
      if (L === 'fr') return '🎉 Vous avez débloqué <strong>25% de réduction</strong> !';
      if (L === 'el') return '🎉 Ξεκλειδώσατε <strong>25% έκπτωση</strong>!';
      if (L === 'es') return '🎉 ¡Has desbloqueado <strong>25% de descuento</strong>!';
      if (L === 'it') return '🎉 Hai sbloccato <strong>25% di sconto</strong>!';
      return "🎉 You've unlocked <strong>25% off</strong>!";
    }
    if (qty === 4) {
      if (L === 'fr') return '<strong>20% de réduction</strong> appliqué — ajoutez <strong>1 article</strong> pour <strong>25%</strong> !';
      if (L === 'el') return '<strong>20% έκπτωση</strong> ενεργή — προσθέστε <strong>1 ακόμα</strong> για <strong>25%</strong>!';
      if (L === 'es') return '<strong>20% de descuento</strong> aplicado — añade <strong>1 más</strong> para <strong>25%</strong>!';
      if (L === 'it') return '<strong>20% di sconto</strong> applicato — aggiungi <strong>1 articolo</strong> per <strong>25%</strong>!';
      return '<strong>20% off</strong> applied — add <strong>1 more</strong> for <strong>25% off</strong>!';
    }
    if (qty === 3) {
      if (L === 'fr') return '<strong>15% de réduction</strong> appliqué — ajoutez <strong>1 article</strong> pour <strong>20%</strong> !';
      if (L === 'el') return '<strong>15% έκπτωση</strong> ενεργή — προσθέστε <strong>1 ακόμα</strong> για <strong>20%</strong>!';
      if (L === 'es') return '<strong>15% de descuento</strong> aplicado — añade <strong>1 más</strong> para <strong>20%</strong>!';
      if (L === 'it') return '<strong>15% di sconto</strong> applicato — aggiungi <strong>1 articolo</strong> per <strong>20%</strong>!';
      return '<strong>15% off</strong> applied — add <strong>1 more</strong> for <strong>20% off</strong>!';
    }
    if (qty === 2) {
      if (L === 'fr') return '<strong>10% de réduction</strong> appliqué — ajoutez <strong>1 article</strong> pour <strong>15%</strong> !';
      if (L === 'el') return '<strong>10% έκπτωση</strong> ενεργή — προσθέστε <strong>1 ακόμα</strong> για <strong>15%</strong>!';
      if (L === 'es') return '<strong>10% de descuento</strong> aplicado — añade <strong>1 más</strong> para <strong>15%</strong>!';
      if (L === 'it') return '<strong>10% di sconto</strong> applicato — aggiungi <strong>1 articolo</strong> per <strong>15%</strong>!';
      return '<strong>10% off</strong> applied — add <strong>1 more</strong> for <strong>15% off</strong>!';
    }
    var need = Math.max(0, 2 - qty);
    if (L === 'fr') return 'Ajoutez <strong>' + need + ' article' + (need !== 1 ? 's' : '') + '</strong> et obtenez <strong>10% de réduction</strong>';
    if (L === 'el') return 'Προσθέστε <strong>' + need + ' ακόμα</strong> για <strong>10% έκπτωση</strong>';
    if (L === 'es') return 'Añade <strong>' + need + ' artículo' + (need !== 1 ? 's' : '') + '</strong> más y obtén <strong>10% de descuento</strong>';
    if (L === 'it') return 'Aggiungi <strong>' + need + ' articol' + (need !== 1 ? 'i' : 'o') + '</strong> e ottieni <strong>10% di sconto</strong>';
    return 'Add <strong>' + need + ' more</strong> and get <strong>10% off</strong>';
  }
  function progressPct(qty) {
    if (qty <= 0) return 0;
    if (qty === 1) return 10;
    if (qty === 2) return 20;
    if (qty === 3) return 40;
    if (qty === 4) return 60;
    return 100;
  }
  function variantSummary(line) {
    // Mirror liquid: "Color: Red, Size: M". options_with_values needs constructing
    // from `options` if available — but cart JSON has line.options_with_values directly.
    if (!line.options_with_values || !line.options_with_values.length) return '';
    if (line.product_has_only_default_variant) return '';
    return line.options_with_values.map(function (o) { return o.name + ': ' + o.value; }).join(', ');
  }

  // ---------- cart math ----------
  function realItems(cart) {
    return (cart.items || []).filter(function (i) { return i.variant_id !== PROTECT; });
  }
  function realQty(cart) {
    return realItems(cart).reduce(function (n, i) { return n + i.quantity; }, 0);
  }
  function hasProtect(cart) {
    return (cart.items || []).some(function (i) { return i.variant_id === PROTECT; });
  }

  // ---------- in-place DOM updates ----------
  function updateProgressBar(cart) {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var qty = realQty(cart);
    var msg = d.querySelector('.tv-prog__msg');
    if (msg) msg.innerHTML = progressHtml(qty);
    var fill = d.querySelector('.tv-prog__fill');
    if (fill) fill.style.width = progressPct(qty) + '%';
    var nodes = d.querySelectorAll('.tv-prog__node');
    var labels = d.querySelectorAll('.tv-prog__labels span');
    [2, 3, 4, 5].forEach(function (tier, i) {
      if (nodes[i]) nodes[i].classList.toggle('is-on', qty >= tier);
      if (labels[i]) labels[i].classList.toggle('is-on', qty >= tier);
    });
  }
  function updateLineItemQty(vid, newQty, newLinePrice) {
    var li = document.querySelector('.tv-li[data-vid="' + vid + '"]'); if (!li) return;
    var num = li.querySelector('.tv-li__qtynum');
    if (num) num.textContent = String(newQty);
    if (newLinePrice != null) {
      // line price might shift if a discount changed; refresh tv-li__now if we know unit price
      // (we update on the response of the change.js call below)
    }
  }
  function updateLinePrice(vid, line) {
    var li = document.querySelector('.tv-li[data-vid="' + vid + '"]'); if (!li) return;
    var priceWrap = li.querySelector('.tv-li__price'); if (!priceWrap) return;
    var html = '';
    if (line.variant && line.variant.compare_at_price && line.variant.compare_at_price > line.price) {
      var save = line.variant.compare_at_price - line.price;
      var saveLabel = locale() === 'fr' ? 'Économisez' : locale() === 'el' ? 'Κέρδος' : 'Save';
      html += '<span class="tv-li__was">' + moneyShop(line.variant.compare_at_price) + '</span>';
      html += '<span class="tv-li__now">' + moneyShop(line.price) + '</span>';
      html += '<span class="tv-li__save">(' + saveLabel + ' ' + moneyShop(save) + ')</span>';
    } else {
      html += '<span class="tv-li__now">' + moneyShop(line.price) + '</span>';
    }
    priceWrap.innerHTML = html;
  }
  function removeLineItemDOM(vid) {
    var li = document.querySelector('.tv-li[data-vid="' + vid + '"]'); if (!li) return Promise.resolve();
    li.style.overflow = 'hidden';
    li.style.transition = 'opacity .15s ease, max-height .25s ease, padding .25s ease, margin .25s ease';
    li.style.maxHeight = li.offsetHeight + 'px';
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        li.style.opacity = '0';
        li.style.maxHeight = '0';
        li.style.padding = '0';
        li.style.margin = '0';
        setTimeout(function () { li.remove(); resolve(); }, 260);
      });
    });
  }
  function buildLineItemHTML(line) {
    var L = locale();
    var removeLabel = L === 'fr' ? 'Retirer' : L === 'el' ? 'Αφαίρεση' : 'Remove';
    var saveLabel = L === 'fr' ? 'Économisez' : L === 'el' ? 'Κέρδος' : 'Save';
    var qtyLabel = L === 'fr' ? 'Quantité' : L === 'el' ? 'Ποσότητα' : 'Quantity';
    var img = line.image ? '<img class="tv-li__img" loading="lazy" src="' + (line.image.indexOf('?') > -1 ? line.image : line.image + '?width=180') + '">' : '';
    var variantStr = variantSummary(line);
    var priceHtml = '';
    if (line.variant && line.variant.compare_at_price && line.variant.compare_at_price > line.price) {
      var save = line.variant.compare_at_price - line.price;
      priceHtml = '<span class="tv-li__was">' + moneyShop(line.variant.compare_at_price) + '</span>' +
                  '<span class="tv-li__now">' + moneyShop(line.price) + '</span>' +
                  '<span class="tv-li__save">(' + saveLabel + ' ' + moneyShop(save) + ')</span>';
    } else {
      priceHtml = '<span class="tv-li__now">' + moneyShop(line.price) + '</span>';
    }
    return '<div class="tv-li" data-vid="' + line.variant_id + '">' +
      '<a href="' + line.url + '" class="tv-li__imgwrap">' + img + '</a>' +
      '<div class="tv-li__main">' +
        '<div class="tv-li__top">' +
          '<a href="' + line.url + '" class="tv-li__title">' + (line.product_title || line.title) + '</a>' +
          '<button type="button" class="tv-li__remove" data-tv-remove="' + line.variant_id + '" aria-label="' + removeLabel + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6"/><path d="M10 11v6M14 11v6"/></svg>' +
          '</button>' +
        '</div>' +
        (variantStr ? '<p class="tv-li__variant">' + variantStr + '</p>' : '') +
        '<div class="tv-li__price">' + priceHtml + '</div>' +
        '<div class="tv-li__qty" role="group" aria-label="' + qtyLabel + '">' +
          '<button type="button" class="tv-li__qtybtn" data-tv-qty="dec" data-vid="' + line.variant_id + '" aria-label="-">−</button>' +
          '<span class="tv-li__qtynum">' + line.quantity + '</span>' +
          '<button type="button" class="tv-li__qtybtn" data-tv-qty="inc" data-vid="' + line.variant_id + '" aria-label="+">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  function appendOrUpdateLineFromCart(cart, vid) {
    var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
    if (!line) return;
    var existing = document.querySelector('.tv-li[data-vid="' + vid + '"]');
    if (existing) {
      // already in DOM — just update qty + price
      updateLineItemQty(vid, line.quantity);
      updateLinePrice(vid, line);
      return;
    }
    var items = document.querySelector('.tv-items'); if (!items) return;
    items.insertAdjacentHTML('beforeend', buildLineItemHTML(line));
  }
  function updateAllLinePrices(cart) {
    realItems(cart).forEach(function (line) {
      updateLineItemQty(line.variant_id, line.quantity);
      updateLinePrice(line.variant_id, line);
    });
  }
  function updateTotalAndCheckoutBtn(cart) {
    var price = document.querySelector('.tv-checkout__price');
    if (price) price.textContent = moneyShop(cart.total_price);
  }
  function updateCartCount(cart) {
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.textContent = String(cart.item_count);
      if ('itemCount' in el) try { el.itemCount = cart.item_count; } catch (e) {}
    });
  }
  function updateProtectionToggle(cart) {
    var tg = document.querySelector('[data-tv-protect-toggle]');
    if (tg) tg.checked = hasProtect(cart);
  }
  function refreshAllDrawerUI(cart) {
    updateProgressBar(cart);
    updateTotalAndCheckoutBtn(cart);
    updateCartCount(cart);
    updateProtectionToggle(cart);
  }

  // ---------- low-level POSTs WITHOUT sections (no Impact re-render) ----------
  // /cart/change.js returns the full cart. /cart/add.js only returns the added line.
  // Always follow with /cart.js so callers get a consistent full-cart payload.
  async function postChange(lineKey, quantity) {
    await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
    return getCart();
  }
  async function postAdd(variantId, quantity) {
    await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    });
    return getCart();
  }
  function broadcast(cart) {
    // NOTE: cannot dispatch cart:change OR cart:refresh — Impact's CartDrawer
    // listens to BOTH and does a fresh `/?section_id=...` fetch + replaceChildren,
    // which is exactly the wipe we're trying to avoid. The header cart-count is
    // updated directly by updateCartCount(); other outside listeners don't need
    // syncing here because they all hit /cart.js themselves when they need state.
  }

  async function ensureProtect(cart) {
    if (lock) return cart;
    if (realItems(cart).length === 0) {
      if (hasProtect(cart)) {
        var pline = (cart.items || []).filter(function (i) { return i.variant_id === PROTECT; })[0];
        if (pline) { lock = true; try { cart = await postChange(pline.key, 0); } catch (e) {} finally { lock = false; } }
      }
      return cart;
    }
    if (localStorage.getItem(OPTOUT) === '1') return cart;
    if (hasProtect(cart)) return cart;
    lock = true;
    try { cart = await postAdd(PROTECT, 1); } catch (e) {} finally { lock = false; }
    return cart;
  }

  async function getCart() {
    var r = await fetch(root + 'cart.js'); return r.json();
  }

  // ---------- ACTIONS ----------
  // toggle protection on/off — in-place
  async function actionToggleProtect(checked) {
    if (lock) return;
    lock = true;
    try {
      var cart;
      if (checked) {
        localStorage.removeItem(OPTOUT);
        cart = await postAdd(PROTECT, 1);
      } else {
        localStorage.setItem(OPTOUT, '1');
        var c0 = await getCart();
        var pline = (c0.items || []).filter(function (i) { return i.variant_id === PROTECT; })[0];
        if (pline) { cart = await postChange(pline.key, 0); } else { cart = c0; }
      }
      // The cart-level discounts on Thomvale may shift line prices when protection
      // crosses the discount threshold — refresh every line's price + qty + total + progress.
      updateAllLinePrices(cart);
      refreshAllDrawerUI(cart);
      broadcast(cart);
    } catch (e) {}
    finally { lock = false; }
  }

  // qty +/− — in-place
  var qtyBusy = false;
  async function actionQty(vid, dir) {
    if (qtyBusy) return; qtyBusy = true;
    try {
      var c0 = await getCart();
      var line = (c0.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (!line) return;
      var nq = Math.max(0, line.quantity + dir);
      var cart;
      if (nq === 0) {
        await removeLineItemDOM(vid);
        cart = await postChange(line.key, 0);
        cart = await ensureProtect(cart);
        if (realItems(cart).length === 0) { return finalizeEmptyCart(); }
      } else {
        // OPTIMISTIC: bump number immediately
        updateLineItemQty(vid, nq);
        cart = await postChange(line.key, nq);
      }
      updateAllLinePrices(cart);
      refreshAllDrawerUI(cart);
      broadcast(cart);
    } catch (e) {}
    finally { qtyBusy = false; }
  }

  // trash → remove line — in-place
  async function actionRemove(vid) {
    try {
      await removeLineItemDOM(vid);
      var c0 = await getCart();
      var line = (c0.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      var cart = c0;
      if (line) cart = await postChange(line.key, 0);
      cart = await ensureProtect(cart);
      if (realItems(cart).length === 0) { return finalizeEmptyCart(); }
      updateAllLinePrices(cart);
      refreshAllDrawerUI(cart);
      broadcast(cart);
    } catch (e) {}
  }

  // +Add from recs slider — in-place
  async function actionAddFromRec(vid, btn) {
    if (!vid) return;
    if (btn) btn.setAttribute('disabled', 'true');
    try {
      var cart = await postAdd(vid, 1);
      cart = await ensureProtect(cart);
      // either append new line or bump existing
      appendOrUpdateLineFromCart(cart, vid);
      updateAllLinePrices(cart);
      refreshAllDrawerUI(cart);
      // hide this rec card from the slider (since it's now in cart)
      if (btn) {
        var card = btn.closest('.tv-rec');
        if (card) card.style.display = 'none';
      }
      broadcast(cart);
    } catch (e) {}
    finally { if (btn) btn.removeAttribute('disabled'); }
  }

  // when the last real item is removed → show the server-rendered empty state.
  // we do a one-time cart:refresh so the cart count clears; the drawer body is
  // swapped manually to a minimal empty-state DOM.
  // when the cart goes empty, just empty the items list and reset counters/UI —
  // KEEP the recs slider visible so the customer can re-add easily. NO innerHTML
  // swap (that would wipe the recs DOM and you'd lose the "Others also bought" cards).
  function finalizeEmptyCart() {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var L = locale();
    var emptyText = L === 'fr' ? 'Votre panier est vide' : L === 'el' ? 'Το καλάθι σας είναι άδειο' : 'Your cart is empty';
    // empty the line-items area but keep the wrapper so the recs section below stays intact
    var items = d.querySelector('.tv-items');
    if (items) items.innerHTML = '<p class="tv-li-empty" style="text-align:center;padding:24px 16px;font-size:14px;color:rgba(0,0,0,.55);margin:0;">' + emptyText + '</p>';
    // progress bar: reset to 0
    var msg = d.querySelector('.tv-prog__msg');
    if (msg) msg.innerHTML = progressHtml(0);
    var fill = d.querySelector('.tv-prog__fill'); if (fill) fill.style.width = '0%';
    d.querySelectorAll('.tv-prog__node').forEach(function (n) { n.classList.remove('is-on'); });
    d.querySelectorAll('.tv-prog__labels span').forEach(function (s) { s.classList.remove('is-on'); });
    // total + checkout button
    var price = d.querySelector('.tv-checkout__price'); if (price) price.textContent = moneyShop(0);
    // count bubble (drawer + header)
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.textContent = '0';
      if ('itemCount' in el) try { el.itemCount = 0; } catch (e) {}
    });
    // protection toggle off
    var tg = d.querySelector('[data-tv-protect-toggle]'); if (tg) tg.checked = false;
    // recs stays as-is — it's an `<div class="tv-recs">` outside `.tv-items` and we don't touch it
  }

  // ---------- EVENT DELEGATION ----------
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var qtyBtn = e.target.closest('[data-tv-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var vid = Number(qtyBtn.getAttribute('data-vid'));
      var dir = qtyBtn.getAttribute('data-tv-qty') === 'inc' ? 1 : -1;
      if (vid) actionQty(vid, dir);
      return;
    }
    var trash = e.target.closest('[data-tv-remove]');
    if (trash) {
      e.preventDefault();
      var vid2 = Number(trash.getAttribute('data-tv-remove'));
      if (vid2) actionRemove(vid2);
      return;
    }
    var recAdd = e.target.closest('[data-tv-rec-add]');
    if (recAdd) {
      e.preventDefault();
      var id = recAdd.getAttribute('data-tv-rec-add');
      var card = recAdd.closest('.tv-rec');
      var sel = card ? card.querySelector('[data-tv-rec-variant]') : null;
      if (sel && sel.value) id = sel.value;
      if (id) actionAddFromRec(Number(id), recAdd);
      return;
    }
    if (e.target.closest('[data-tv-recs-prev]')) { e.preventDefault(); recScroll(-1); return; }
    if (e.target.closest('[data-tv-recs-next]')) { e.preventDefault(); recScroll(1); return; }
  });

  document.addEventListener('change', function (e) {
    var tg = e.target.closest ? e.target.closest('[data-tv-protect-toggle]') : null;
    if (tg) actionToggleProtect(tg.checked);
  });

  // ---------- RECS slider ----------
  // Index-based scroll: find the card currently aligned to the left edge, then
  // scrollIntoView on the next/prev one. Avoids the bug where `scrollBy(cardWidth)`
  // lands between snap points and `scroll-snap-type: x mandatory` reverts to the start.
  function recScroll(dir) {
    var list = document.querySelector('[data-tv-recs-list]'); if (!list) return;
    var cards = list.querySelectorAll('.tv-rec');
    if (!cards.length) return;
    var scrollLeft = list.scrollLeft;
    var currentIdx = 0;
    for (var i = 0; i < cards.length; i++) {
      // pick the latest card whose left edge is at or before current scroll position
      if (cards[i].offsetLeft - list.offsetLeft <= scrollLeft + 8) currentIdx = i;
    }
    var nextIdx = Math.max(0, Math.min(cards.length - 1, currentIdx + dir));
    if (nextIdx === currentIdx) return; // already at edge
    var targetLeft = cards[nextIdx].offsetLeft - list.offsetLeft;
    list.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  // /recommendations/products.json returns price as INT cents (e.g. 4495 = $44.95)
  // /products.json returns price as STRING major units (e.g. "54.95")
  // We normalize to cents so moneyFmt(cents) works for both.
  function priceToCents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return v; // /recommendations
    return Math.round(parseFloat(v) * 100); // /products.json string
  }
  function normalizeRecsProducts(arr, sourceTag) {
    return arr.map(function (p) {
      var pp = Object.assign({}, p);
      pp.price = priceToCents(p.price);
      pp.compare_at_price = p.compare_at_price != null ? priceToCents(p.compare_at_price) : null;
      pp.variants = (p.variants || []).map(function (v) {
        var vv = Object.assign({}, v);
        vv.price = priceToCents(v.price);
        return vv;
      });
      pp.__src = sourceTag;
      return pp;
    });
  }
  async function fetchRecsFor(pid) {
    try {
      var r = await fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=20&intent=related');
      var d = await r.json();
      if (d && Array.isArray(d.products)) return normalizeRecsProducts(d.products, 'rec');
    } catch (e) {}
    return [];
  }
  async function fetchGeneralProducts() {
    try {
      var r = await fetch(root + 'products.json?limit=20');
      var d = await r.json();
      if (d && Array.isArray(d.products)) return normalizeRecsProducts(d.products.filter(function (p) { return p.published_at; }), 'gen');
    } catch (e) {}
    return [];
  }

  async function loadRecs() {
    var wrap = document.querySelector('[data-tv-recs]');
    var list = document.querySelector('[data-tv-recs-list]');
    if (!wrap || !list) return;
    var cart; try { cart = await getCart(); } catch (e) { return; }
    var items = realItems(cart);
    if (!items.length) { wrap.hidden = true; return; }
    var key = items.map(function (i) { return i.product_id; }).sort().join(',');
    if (key === recsKey && list.children.length) { wrap.hidden = false; return; }
    if (key === recsKey && recsHtml) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
    var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });
    var raw = [];
    for (var i = 0; i < items.length; i++) {
      raw = await fetchRecsFor(items[i].product_id);
      if (raw.length) break;
    }
    if (!raw.length) raw = await fetchGeneralProducts();
    var prods = raw.filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 8);
    if (!prods.length) {
      if (recsHtml) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); }
      else if (list.children.length) { wrap.hidden = false; }
      else { wrap.hidden = true; }
      return;
    }
    var html = '';
    var aLabel = addLabel();
    prods.forEach(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var priceHtml;
      if (p.compare_at_price && p.compare_at_price > p.price) {
        priceHtml = '<span class="tv-rec__was">' + moneyFmt(p.compare_at_price) + '</span> <span class="tv-rec__now">' + moneyFmt(p.price) + '</span>';
      } else {
        priceHtml = '<span class="tv-rec__now">' + moneyFmt(p.price) + '</span>';
      }
      var variants = (p.variants || []).filter(function (v) { return v.available; });
      var firstId = variants.length ? variants[0].id : (p.variants && p.variants[0] && p.variants[0].id) || '';
      var sel = '';
      if (variants.length > 1) {
        sel = '<select class="tv-rec__variant" data-tv-rec-variant>';
        variants.forEach(function (v) { sel += '<option value="' + v.id + '">' + (v.title || '') + '</option>'; });
        sel += '</select>';
      }
      html += '<div class="tv-rec">' +
        '<a class="tv-rec__imgwrap" href="' + p.url + '"><img class="tv-rec__img" src="' + img + '" alt="" loading="lazy"></a>' +
        '<div class="tv-rec__body">' +
          '<a class="tv-rec__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="tv-rec__price">' + priceHtml + '</div>' +
          '<div class="tv-rec__actions">' + sel +
            '<button type="button" class="tv-rec__add" data-tv-rec-add="' + firstId + '">' + aLabel + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    list.innerHTML = html;
    recsHtml = html;
    recsKey = key;
    wrap.hidden = false;
    enableSwipe(list);
  }

  function enableSwipe(list) {
    if (list.__tvSwipe) return; list.__tvSwipe = true;
    var section = list.closest('.tv-recs') || list;
    ['touchstart', 'touchmove', 'touchend', 'pointerdown'].forEach(function (ev) {
      section.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
    });
    var down = false, startX = 0, startScroll = 0, moved = false, captured = false, pid = null;
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') { down = true; moved = false; captured = false; pid = e.pointerId; startX = e.clientX; startScroll = list.scrollLeft; }
    });
    list.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) { moved = true; try { list.setPointerCapture(pid); captured = true; } catch (x) {} }
      if (moved) list.scrollLeft = startScroll - dx;
    });
    function end() { down = false; if (captured) { try { list.releasePointerCapture(pid); } catch (x) {} captured = false; } }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);
    list.addEventListener('pointerleave', end);
    list.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  // ---------- BOOTSTRAP ----------
  // Load recs when drawer opens (Impact toggles `open` attribute) and on cart icon click backup.
  function onDrawerOpened() {
    loadRecs();
    getCart().then(function (c) { return ensureProtect(c); }).then(function (c) {
      if (c) { refreshAllDrawerUI(c); updateAllLinePrices(c); }
    }).catch(function () {});
  }
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () { if (drawer.hasAttribute('open')) onDrawerOpened(); })
      .observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
  // backup: cart icon click
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('a[aria-controls="cart-drawer"], button[aria-controls="cart-drawer"], [data-cart-toggle]')) {
      setTimeout(onDrawerOpened, 250);
    }
  });

  // initial protection bootstrap (in case cart already has items on page load)
  getCart().then(ensureProtect).catch(function () {});

  // we NEVER dispatch cart:change or cart:refresh ourselves (both trigger Impact's
  // CartDrawer to fetch ?section_id=...&cart-drawer and replaceChildren — exactly
  // the wipe we're avoiding). If something ELSE in the page fires them (e.g. PDP
  // product form auto-adding to cart), Impact will rebuild the drawer; we just
  // need to make sure our state is fresh next time the drawer opens. The MutationObserver
  // on the drawer's `open` attribute handles that.
})();
